import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function RouteScrollToTop() {
  const { pathname, search } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Preserve browser back/forward scroll restoration.
    if (navigationType === 'POP') return;

    // Defer to the next frame so the new route can render first.
    requestAnimationFrame(() => {
      const scrollingElement = document.scrollingElement || document.documentElement;
      try {
        scrollingElement.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } catch {
        // Older browsers
        scrollingElement.scrollTop = 0;
        scrollingElement.scrollLeft = 0;
      }

      // Also reset the window just in case the app scrolls the viewport.
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });
  }, [pathname, search, navigationType]);

  return null;
}
